<template>
  <div class="molded-seat-step-two">
    <v-switch
      v-model="form.idc_stud"
      hide-details
      label="Plot :"
      class="title"
      @change="clearStudFields"
    />
    <v-layout
      wrap
      justify-space-between
    >
      <v-flex sm6>
        <v-radio-group
          v-model="form.stud_type"
          :disabled="!form.idc_stud"
        >
          <v-radio
            label="FIXE"
            value="FIXED"
          />
          <v-radio
            label="AMOVIBLE"
            value="REMOVABLE"
          />
        </v-radio-group>
      </v-flex>

      <v-flex
        sm6
        mb-4
      >
        <div class="cadre mt-3">
          <h3 class="mb-3">
            Zone Option
          </h3>
          <div
            v-if="form.stud_type == 'FIXED' || form.stud_type == null"
            class="option-fixe"
          >
            <v-text-field
              v-model="form.fixed_stud"
              class="mb-1"
              hide-details
              maxlength="15"
              outlined
              :disabled="!form.idc_stud"
            />
          </div>
          <div
            v-if="form.stud_type == 'REMOVABLE'"
            class="option-amovible"
          >
            <v-radio-group
              v-model="form.removable_type"
              class="mt-0"
              hide-details
              :disabled="!form.idc_stud"
            >
              <v-radio
                class="mb-3"
                hide-details
                label="Albatros"
                value="ALBATROS"
              />
              <v-radio
                hide-details
                label="Vélo"
                value="BIKE"
              />
              <v-layout
                class="checkbox-input-container"
                align-center
              >
                <v-flex sm6>
                  <v-radio
                    hide-details
                    label="Autres"
                    value="OTHER"
                  />
                </v-flex>
                <v-flex
                  sm6
                  class="checkbox-input visible"
                >
                  <v-text-field
                    v-model="form.other_stud"
                    maxlength="15"
                    hide-details
                    outlined
                    :disabled="!form.idc_stud"
                  />
                </v-flex>
              </v-layout>
            </v-radio-group>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-switch
        v-model="form.is_foam_section_enabled"
        hide-details
        class="mb-4 title"
        label="Mousse :"
        @change="handleFoamToggle"
      />
    </v-layout>

    <v-layout
      wrap
      justify-space-between
      mb-6
    >
      <v-flex sm4>
        <v-text-field
          v-model="form.thickness_plasta"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('Epaisseur Plasta') }"
          data-vv-name="Epaisseur Plasta"
          hide-details
          class="mb-3"
          label="Epaisseur Plasta (mm)"
          type="number"
          outlined
          :disabled="!form.is_foam_section_enabled"
        />
      </v-flex>
      <v-flex sm4>
        <v-text-field
          v-model="form.thickness_evazote"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('Epaisseur Evazote') }"
          data-vv-name="Epaisseur Evazote"
          hide-details
          class="mb-3"
          label="Epaisseur Evazote (mm)"
          type="number"
          outlined
          :disabled="!form.is_foam_section_enabled"
        />
      </v-flex>
      <v-flex sm4>
        <v-text-field
          v-model="form.thickness_foam"
          v-validate="'numeric|max:4'"
          :class="{ error: errors.has('Epaisseur Mousse') }"
          data-vv-name="Epaisseur Mousse"
          hide-details
          class="mb-3"
          label="Epaisseur Mousse (mm)"
          type="number"
          outlined
          :disabled="!form.is_foam_section_enabled"
        />
      </v-flex>

      <v-flex sm6>
        <v-checkbox
          v-model="form.idc_anti_pressure_ulcers"
          :disabled="!form.is_foam_section_enabled"
          hide-details
          class="ma-0"
          label="Anti Escarres"
        />
      </v-flex>
      <v-flex sm6>
        <v-select
          v-model="form.matter"
          :items="dropdowns.matter"
          item-text="label"
          item-value="value"
          label="Matière"
          filled
          clearable
          hide-details
          @click:clear="$nextTick(() => (form.matter = null))"
          :disabled="!form.is_foam_section_enabled"
        />
      </v-flex>
    </v-layout>

    <v-switch
        v-model="form.is_foam_finition_enabled"
        hide-details
        class="mb-4 title"
        label="Finition :"
        :disabled="!form.is_foam_section_enabled"
      />
    <v-layout
      justify-space-between
      mb-6
    >
      <v-flex sm6>
        <v-checkbox
          v-model="form.idc_coating"
          hide-details
          class="mb-3 mt-0"
          label="Coating"
          :disabled="!form.is_foam_section_enabled || !form.is_foam_finition_enabled"
        />

        <v-layout class="color-select">
          <v-select
            v-model="form.plastazote_color_id"
            :items="plastaColors"
            item-text="label"
            item-value="id"
            class="mb-3"
            hide-details
            label="Plastazote Couleur"
            filled
            clearable
            :disabled="!form.is_foam_section_enabled || !form.is_foam_finition_enabled"
            @click:clear="$nextTick(() => (form.plastazote_color_id = null))"
          />
          <template v-if="previewPlastaColor">
            <v-flex
              v-if="previewPlastaColor.texture == 'TEXTURE'"
              class="preview"
              style="width: 35px; height: 35px"
            >
              <img
                :src="previewPlastaColor.image"
                style="width: 100%; height:100%"
                alt
              >
            </v-flex>
            <v-flex
              v-else-if="previewPlastaColor.texture == 'COLOR'"
              class="preview"
              :style="{ 'background-color': '#' + previewPlastaColor.rgb_code }"
            />
          </template>
        </v-layout>
      </v-flex>

      <v-flex sm6>
        <v-layout class="color-select">
          <v-select
            v-model="form.thermozaique_color_id"
            :items="thermoColors"
            item-text="label"
            item-value="id"
            class="mb-3"
            hide-details
            label="Thermozaic Couleur"
            filled
            clearable
            :disabled="!form.is_foam_section_enabled || !form.is_foam_finition_enabled"
            @click:clear="$nextTick(() => (form.thermozaique_color_id = null))"
          />
          <template v-if="previewThermoColor">
            <v-flex
              v-if="previewThermoColor.texture == 'TEXTURE'"
              class="preview"
              style="width: 35px; height: 35px"
            >
              <img
                :src="previewThermoColor.image"
                style="width: 100%; height:100%"
                alt
              >
            </v-flex>
            <v-flex
              v-else-if="previewThermoColor.texture == 'COLOR'"
              class="preview"
              :style="{ 'background-color': '#' + previewThermoColor.rgb_code }"
            />
          </template>
        </v-layout>

        <v-layout class="color-select">
          <v-select
            v-model="form.evazote_color_id"
            :items="evazoteColors"
            item-text="label"
            item-value="id"
            class="mb-3"
            hide-details
            label="Evazote Couleur"
            filled
            clearable
            :disabled="!form.is_foam_section_enabled || !form.is_foam_finition_enabled"
            @click:clear="$nextTick(() => (form.evazote_color_id = null))"
          />
          <template v-if="previewEvazoteColor">
            <v-flex
              v-if="previewEvazoteColor.texture == 'TEXTURE'"
              class="preview"
              style="width: 35px; height: 35px"
            >
              <img
                :src="previewEvazoteColor.image"
                style="width: 100%; height:100%"
                alt
              >
            </v-flex>
            <v-flex
              v-else-if="previewEvazoteColor.texture == 'COLOR'"
              class="preview"
              :style="{
                'background-color': '#' + previewEvazoteColor.rgb_code
              }"
            />
          </template>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-switch
        v-model="form.is_foam_finition_skai_enabled"
        hide-details
        class="mb-4 title"
        label="Finition Skai :"
        :disabled="!form.is_foam_section_enabled"
      />
    <v-layout
      justify-space-between
      mb-4
    >
      <v-flex sm5>
        <v-text-field
          v-model="form.backrest"
          maxlength="15"
          class="mb-3"
          label="Dossier"
          hide-details
          outlined
          :disabled="!form.is_foam_section_enabled || !form.is_foam_finition_skai_enabled"
        />
        <v-layout class="color-select">
          <v-select
            v-model="form.intern_skai_color_id"
            :items="skaiColors"
            item-value="id"
            item-text="label"
            class="mb-3"
            hide-details
            label="Couleur interne"
            filled
            clearable
            :disabled="!form.is_foam_section_enabled || !form.is_foam_finition_skai_enabled"
            @click:clear="$nextTick(() => (form.intern_skai_color_id = null))"
          />
          <template v-if="previewSkaiInternColor">
            <v-flex
              v-if="previewSkaiInternColor.texture == 'TEXTURE'"
              class="preview"
              style="width: 35px; height: 35px"
            >
              <img
                :src="previewSkaiInternColor.image"
                style="width: 100%; height:100%"
                alt
              >
            </v-flex>
            <v-flex
              v-else-if="previewSkaiInternColor.texture == 'COLOR'"
              class="preview"
              :style="{
                'background-color': '#' + previewSkaiInternColor.rgb_code
              }"
            />
          </template>
        </v-layout>
      </v-flex>

      <v-flex sm5>
        <v-text-field
          v-model="form.seated"
          maxlength="15"
          class="mb-3"
          label="Assise"
          hide-details
          outlined
          :disabled="!form.is_foam_section_enabled || !form.is_foam_finition_skai_enabled"
        />
        <v-layout class="color-select">
          <v-select
            v-model="form.extern_skai_color_id"
            :items="skaiColors"
            item-value="id"
            item-text="label"
            class="mb-3"
            hide-details
            label="Couleur externe"
            filled
            clearable
            :disabled="!form.is_foam_section_enabled || !form.is_foam_finition_skai_enabled"
            @click:clear="$nextTick(() => (form.extern_skai_color_id = null))"
          />
          <template v-if="previewSkaiExternColor">
            <v-flex
              v-if="previewSkaiExternColor.texture == 'TEXTURE'"
              class="preview"
              style="width: 35px; height: 35px"
            >
              <img
                :src="previewSkaiExternColor.image"
                style="width: 100%; height:100%"
                alt
              >
            </v-flex>
            <v-flex
              v-else-if="previewSkaiExternColor.texture == 'COLOR'"
              class="preview"
              :style="{
                'background-color': '#' + previewSkaiExternColor.rgb_code
              }"
            />
          </template>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-textarea
      v-model="form.skai_comment"
      filled
      name="Ajouter un commentaire :"
      label="Ajouter un commentaire :"
      :disabled="!form.is_foam_section_enabled || !form.is_foam_finition_skai_enabled"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MoldedSeatStepTwo",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      thermoColors: "colors/getTHERMOType",
      plastaColors: "colors/getPLASTAType",
      evazoteColors: "colors/getEVAZOTEType",
      skaiColors: "colors/getSKAIType",

      dropdowns: "dropdowns/getMoldedSeatOptions"
    }),

    previewPlastaColor() {
      return this.plastaColors.find(
        color => color.id == this.form.plastazote_color_id
      );
    },

    previewThermoColor() {
      return this.thermoColors.find(
        color => color.id == this.form.thermozaique_color_id
      );
    },

    previewEvazoteColor() {
      return this.evazoteColors.find(
        color => color.id == this.form.evazote_color_id
      );
    },

    previewSkaiInternColor() {
      return this.skaiColors.find(
        color => color.id == this.form.intern_skai_color_id
      );
    },

    previewSkaiExternColor() {
      return this.skaiColors.find(
        color => color.id == this.form.extern_skai_color_id
      );
    }
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear stud fields
    clearStudFields() {
      this.form.stud_type = null;
      this.form.fixed_stud = null;
      this.form.removable_type = null;
      this.form.other_stud = null;
    },

    // Handle foam section toggle
    handleFoamToggle() {
      if (!this.form.is_foam_section_enabled) {
        // Reset foam section fields when disabled
        this.form.thickness_plasta = null;
        this.form.thickness_evazote = null;
        this.form.thickness_foam = null;
        this.form.idc_anti_pressure_ulcers = false;
        this.form.matter = null;
        
        // Reset finition section
        this.form.is_foam_finition_enabled = false;
        this.form.idc_coating = false;
        this.form.plastazote_color_id = null;
        this.form.thermozaique_color_id = null;
        this.form.evazote_color_id = null;
        
        // Reset finition skai section
        this.form.is_foam_finition_skai_enabled = false;
        this.form.backrest = null;
        this.form.seated = null;
        this.form.intern_skai_color_id = null;
        this.form.extern_skai_color_id = null;
        this.form.skai_comment = null;
      }
    }
  }
};
</script>

<style lang="scss">
.molded-seat-step-two {
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: none !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
  .cadre {
    background-color: rgb(235, 245, 245);
    height: 160px;
    padding: 10px;
    border-radius: 4px;
  }
}
</style>
